import type { components } from '../api/active/generated/openapi';
import type { SaveQuoteDraftRequest } from '../api/active/generated/quote';

type PackageDefinition = components['schemas']['QuoteLocalPackageDefinition'];
export type QuoteLocalPackageDefinitionWrite = Omit<
  PackageDefinition,
  'packageGroupPolicySnapshot'
>;

/** Internal/frozen policy snapshots are read facts, never command fields. */
export function quoteLocalPackageDefinitionWrite(
  definition: QuoteLocalPackageDefinitionWrite,
): QuoteLocalPackageDefinitionWrite {
  return {
    id: definition.id,
    name: definition.name,
    sortOrder: definition.sortOrder,
    resourceVersion: definition.resourceVersion,
    members: definition.members.map((member) => ({
      deviceId: member.deviceId,
      quantity: member.quantity,
    })),
    ...(definition.packageGroupId !== undefined
      ? { packageGroupId: definition.packageGroupId }
      : {}),
    ...(definition.mergePricesOverride !== undefined
      ? { mergePricesOverride: definition.mergePricesOverride }
      : {}),
  };
}

export function quoteDraftWrite(
  body: SaveQuoteDraftRequest,
): SaveQuoteDraftRequest {
  return body.localPackageDefinitions === undefined
    ? body
    : {
        ...body,
        localPackageDefinitions: body.localPackageDefinitions.map(
          quoteLocalPackageDefinitionWrite,
        ),
      };
}
